export const QUESTION = 'Biology by experts'

export const UNIVERSITIES = ['Harvard', 'Oxford', 'Cambridge']
